// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filters_wrapper__2WnrS","deleteAll":"filters_deleteAll__orlKt","icon":"filters_icon__ovrDy"};